import { withInstall } from '@xzx-design/utils'
import _Select from './src/select'
import _SelectGroup from './src/select-group'

export const Select = withInstall(_Select)
export default Select
export const SelectGroup = withInstall(_SelectGroup)

export * from './src/select'
export * from './src/select-group'
export * from './src/select-column'
export * from './src/select-toolbar'
export * from './src/types'
